import { testimonials } from '../../../mocks/britfit';

export default function Testimonials() {
  const col1 = testimonials.filter((_, i) => i % 3 === 0);
  const col2 = testimonials.filter((_, i) => i % 3 === 1);
  const col3 = testimonials.filter((_, i) => i % 3 === 2);

  const Card = ({ t }: { t: typeof testimonials[0] }) => (
    <div className="bg-white rounded-2xl p-5 mb-5">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div
            className="w-10 h-10 flex-none rounded-full flex items-center justify-center text-stone-700 font-bold text-sm"
            style={{ backgroundColor: t.color }}
          >
            {t.initials}
          </div>
          <div>
            <div className="text-stone-900 text-sm font-semibold">{t.name}</div>
            <div className="text-stone-400 text-xs">{t.location} · {t.date}</div>
          </div>
        </div>
        <div className="flex gap-0.5">
          {[...Array(5)].map((_, i) => (
            <i key={i} className="ri-star-fill text-yellow-400 text-xs" />
          ))}
        </div>
      </div>
      <p className="text-stone-600 text-sm leading-relaxed">
        &ldquo;{t.text}&rdquo;
      </p>
      <div className="mt-3 flex items-center gap-1 text-[#1B4332] text-xs font-semibold">
        <i className="ri-verified-badge-line" /> Verified Customer
      </div>
    </div>
  );

  return (
    <section className="bg-[#F8F7F4] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="mb-12">
          <span className="inline-block bg-white text-stone-500 text-xs font-semibold px-4 py-1.5 rounded-full border border-stone-200 mb-4">
            Customer Reviews
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-stone-900 leading-tight" style={{ fontFamily: 'Syne, sans-serif' }}>
            What Our Customers<br />
            Say About Us
          </h2>
        </div>

        {/* Masonry grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          <div>{col1.map((t) => <Card key={t.id} t={t} />)}</div>
          <div className="lg:mt-10">{col2.map((t) => <Card key={t.id} t={t} />)}</div>
          <div className="hidden lg:block">{col3.map((t) => <Card key={t.id} t={t} />)}</div>
        </div>

        {/* Summary bar */}
        <div className="mt-12 bg-[#1B4332] rounded-2xl px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="text-4xl font-bold text-white" style={{ fontFamily: 'Syne, sans-serif' }}>4.9</div>
            <div>
              <div className="flex gap-0.5 mb-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400" />
                ))}
              </div>
              <div className="text-green-200 text-xs">Based on 2,400+ verified reviews</div>
            </div>
          </div>
          <div className="flex flex-wrap gap-6">
            {[
              { val: '98%', label: 'Would recommend' },
              { val: '96%', label: 'On-time arrival' },
              { val: '99%', label: 'Job completed first visit' },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <div className="text-xl font-bold text-white">{s.val}</div>
                <div className="text-green-300 text-xs mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
